// https://docs.unlayer.com/builder/font-management/default-fonts
export const UNLAYER_DEFAULT_FONTS = [
    {
        label: 'Andale Mono',
        value: 'andale mono,times',
    },
    {
        label: 'Arial',
        value: 'arial,helvetica,sans-serif',
    },
    {
        label: 'Arial Black',
        value: 'arial black,avant garde,arial',
    },
    {
        label: 'Book Antiqua',
        value: 'book antiqua,palatino',
    },
    {
        label: 'Comic Sans MS',
        value: 'comic sans ms,sans-serif',
    },
    {
        label: 'Courier New',
        value: 'courier new,courier',
    },
    {
        label: 'Georgia',
        value: 'georgia,palatino',
    },
    {
        label: 'Helvetica',
        value: 'helvetica,sans-serif',
    },
    {
        label: 'Impact',
        value: 'impact,chicago',
    },
    {
        label: 'Symbol',
        value: 'symbol',
    },
    {
        label: 'Tahoma',
        value: 'tahoma,arial,helvetica,sans-serif',
    },
    {
        label: 'Terminal',
        value: 'terminal,monaco',
    },
    {
        label: 'Times New Roman',
        value: 'times new roman,times',
    },
    {
        label: 'Trebuchet MS',
        value: 'trebuchet ms,geneva',
    },
    {
        label: 'Verdana',
        value: 'verdana,geneva',
    },
    {
        label: 'Lobster Two',
        value: '\'Lobster Two\',cursive',
        url: 'https://fonts.googleapis.com/css?family=Lobster+Two:400,700',
    },
    {
        label: 'Playfair Display',
        value: '\'Playfair Display\',serif',
        url: 'https://fonts.googleapis.com/css?family=Playfair+Display:400,700',
    },
    {
        label: 'Rubik',
        value: '\'Rubik\',sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Rubik:400,700',
    },
    {
        label: 'Source Sans Pro',
        value: '\'Source Sans Pro\',sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700',
    },
    {
        label: 'Open Sans',
        value: '\'Open Sans\',sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Open+Sans:400,700',
    },
    {
        label: 'Crimson Text',
        value: '\'Crimson Text\',serif',
        url: 'https://fonts.googleapis.com/css?family=Crimson+Text:400,700',
    },
    {
        label: 'Montserrat',
        value: '\'Montserrat\',sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Montserrat:400,700',
    },
    {
        label: 'Old Standard TT',
        value: '\'Old Standard TT\',serif',
        url: 'https://fonts.googleapis.com/css?family=Old+Standard+TT:400,700',
    },
    {
        label: 'Lato',
        value: '\'Lato\',sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Lato:400,700',
    },
    {
        label: 'Raleway',
        value: '\'Raleway\',sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Raleway:400,700',
    },
    {
        label: 'Cabin',
        value: '\'Cabin\',sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Cabin:400,700',
    },
    {
        label: 'Pacifico',
        value: '\'Pacifico\',cursive',
        url: 'https://fonts.googleapis.com/css?family=Pacifico',
    },
];

export const CUSTOM_FONTS = [
    {
        label: 'Abhaya Libre',
        value: '\'Abhaya Libre\', serif',
        url: 'https://fonts.googleapis.com/css2?family=Abhaya+Libre',
    },
    {
        label: 'Merriweather',
        value: '\'Merriweather\', serif',
        url: 'https://fonts.googleapis.com/css2?family=Merriweather',
    },
    {
        label: 'Alegreya',
        value: '\'Alegreya\', serif',
        url: 'https://fonts.googleapis.com/css2?family=Alegreya',
    },
    {
        label: 'Aleo',
        value: '\'Aleo\', serif',
        url: 'https://fonts.googleapis.com/css2?family=Aleo',
    },
    {
        label: 'Muli',
        value: '\'Mulish\', sans-serif',
        url: 'https://fonts.googleapis.com/css2?family=Muli',
    },
    {
        label: 'Arapey',
        value: '\'Arapey\', serif',
        url: 'https://fonts.googleapis.com/css2?family=Arapey',
    },
    {
        label: 'Nunito',
        value: '\'Nunito\', sans-serif',
        url: 'https://fonts.googleapis.com/css2?family=Nunito',
    },
    {
        label: 'Asap Condensed',
        value: '\'Asap Condensed\', sans-serif',
        url: 'https://fonts.googleapis.com/css2?family=Asap+Condensed',
    },
    {
        label: 'Assistant',
        value: '\'Assistant\', sans-serif',
        url: 'https://fonts.googleapis.com/css2?family=Assistant',
    },
    {
        label: 'Barlow',
        url: 'https://fonts.googleapis.com/css2?family=Barlow',
        value: '\'Barlow\', sans-serif',
    },
    {
        label: 'Oswald',
        url: 'https://fonts.googleapis.com/css2?family=Oswald',
        value: '\'Oswald\', sans-serif',
    },
    {
        label: 'Bitter',
        url: 'https://fonts.googleapis.com/css?family=Bitter',
        value: '\'Bitter\', serif',
    },
    {
        label: 'Poppins',
        url: 'https://fonts.googleapis.com/css?family=Poppins',
        value: '\'Poppins\', sans-serif',
    },
    {
        label: 'Brawler',
        value: '\'Brawler\', serif',
        url: 'https://fonts.googleapis.com/css?family=Brawler',
    },
    {
        label: 'Roboto',
        value: '\'Roboto\', sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Roboto',
    },
    {
        label: 'Caladea',
        value: '\'Caladea\', serif',
        url: 'https://fonts.googleapis.com/css?family=Caladea',
    },
    {
        label: 'Rokkitt',
        value: '\'Rokkitt\', serif',
        url: 'https://fonts.googleapis.com/css?family=Rokkitt',
    },
    {
        label: 'Carme',
        value: '\'Carme\', sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Carme',
    },
    {
        label: 'Encode Sans Semi Condensed',
        value: '\'Encode Sans Semi Condensed\', sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Encode+Sans+Semi+Condensed',
    },
    {
        label: 'Enriqueta',
        value: '\'Enriqueta\', serif',
        url: 'https://fonts.googleapis.com/css?family=Enriqueta',
    },
    {
        label: 'Frank Ruhl Libre',
        value: '\'Frank Ruhl Libre\', serif',
        url: 'https://fonts.googleapis.com/css?family=Frank+Ruhl+Libre',
    },
    {
        label: 'Spectral',
        value: '\'Spectral\', serif',
        url: 'https://fonts.googleapis.com/css?family=Spectral',
    },
    {
        label: 'Work Sans',
        value: '\'Work Sans\', sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Work+Sans',
    },
    {
        label: 'Gelasio',
        value: '\'Gelasio\', serif',
        url: 'https://fonts.googleapis.com/css?family=Gelasio',
    },
    {
        label: 'Headland One',
        value: '\'Headland One\', serif',
        url: 'https://fonts.googleapis.com/css?family=Headland+One',
    },
    {
        label: 'Great Vibes',
        value: '\'Great Vibes\', cursive',
        url: 'https://fonts.googleapis.com/css?family=Great+Vibes',
    },
    {
        label: 'Griffy',
        value: '\'Griffy\', cursive',
        url: 'https://fonts.googleapis.com/css?family=Griffy',
    },
];

export const RED_HAT_FONT = {
    label: 'Red Hat Display',
    value: 'Red Hat Display, serif',
    url: 'https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;500;700;900',
    weights: [
        { label: 'Regular', value: '400' },
        { label: 'Medium', value: '500' },
        { label: 'Bold', value: '700' },
        { label: 'Black', value: '900' },
    ]
};
